import styled from 'styled-components';

import {
  Card as SemanticCard,
  Dimmer as SemanticDimmer,
  Divider as SemanticDivider,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Button = styled(ButtonLayoutComponent)`
  width: 100px;
`;

export const SkipLogicContainer = styled(SemanticCard)`
  &&& {
    padding: 20px;
    width: 100%;
    overflow: auto;
    max-height: 400px;
  }
`;

export const Divider = styled(SemanticDivider)`
  &&&& {
    border-top: 2px solid #EDEDED;
    margin: 10px 20px 10px 20px;
  }
`;

export const Link = styled.a`
  display: flex;
  justify-content: flex-start;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
`;

export const Title = styled(TextLayoutComponent.Header)`
  text-align: left;
  margin-bottom: 4px;
`;

export const Text = styled(TextLayoutComponent)`
  text-align: left;
  margin-bottom: ${({ padding }) => padding || '10'}px;
`;

export const Container = styled(SemanticDimmer)``;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  text-align: left;
  ${({ padding }) => padding && 'margin-top: 26px;'}
  margin-bottom: 10px;
`;

export const ContainerStatements = styled.div`
  margin-bottom: 5px;
`;
